import BaseModelAPI from '../BaseModelAPI';

export default class PartClassificationList extends BaseModelAPI {

	static entity = 'partclassificationlist'
	static entityName = 'partclassification';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
